import { t } from 'ttag';

import { Title } from '@ui/Title';
import { Button } from '@ui/Button';
import {
  Modal,
  ModalProps,
} from '@ui/Modal';
import { ShopSettingsPaymentMethodsContainer } from '@containers/settings/ShopSettingsPaymentMethods';
import { WorkingStatusSettingsContainer } from '@containers/settings/WorkingStatusSettings';
import { ShopSettingsDeliveryMethodsContainer } from '@containers/settings/ShopSettingsDeliveryMethods';

import s from './DeliveryFlowForSellerModal.sss';

type DeliveryFlowForSellerModalProps = ModalProps & {
  onSubmit: () => void;
};

export const DeliveryFlowForSellerModal: React.FC<DeliveryFlowForSellerModalProps> = ({
  onSubmit,
  ...props
}) => (
  <Modal
    {...props}
    className={s.root}
    overlayClassName={s.overlay}
  >
    <Title
      type="h3"
      className={s.title}
    >
      {t`Оновіть налаштування магазину`}
    </Title>

    <div className={s.settingBlock}>
      <WorkingStatusSettingsContainer className={s.workingStatus} />
    </div>

    <div className={s.settingBlock}>
      <div className={s.settingTitle}>
        {t`Способи доставки`}
      </div>
      <ShopSettingsDeliveryMethodsContainer theme="minimalistic" />
    </div>

    <div className={s.settingBlock}>
      <div className={s.settingTitle}>
        {t`Способи оплати`}
      </div>
      <ShopSettingsPaymentMethodsContainer placement="modal" />
    </div>
    <div className={s.notification}>
      {t`Змінити вибір зможете у «Налаштуваннях магазину»`}
    </div>
    <Button
      className={s.button}
      onClick={onSubmit}
    >
      {t`Готово`}
    </Button>
  </Modal>
);
